import React, { useState } from 'react';
import authService from '../../auth/authService';
import GoogleIcon from '../../assets/googleSSOIcon.svg';
import GithubIcon from '../../assets/githubSSOIcon.svg';
import FacebookIcon from '../../assets/facebookSSOIcon.svg';
import AppleIcon from '../../assets/appleSSOIcon.svg';
import PropTypes from 'prop-types';

import './SocialLogin.scss';

export const ALL_SOCIALS = ['Gsuite', 'GitHub', 'Facebook', 'AppleID'];

export const SocialLogin = ({ permitted }) => {
  const [loadingGoogle, setLoadingGoogle] = useState(false);
  const [loadingGithub, setLoadingGithub] = useState(false);
  const [loadingApple, setLoadingApple] = useState(false);
  const [loadingFacebook, setLoadingFacebook] = useState(false);

  return (
    <div className="social-logins">
      <div className="social-link-container">
        {permitted?.includes('Gsuite') && (
          <button
            className="social-button"
            disabled={loadingGoogle}
            aria-label="Sign-in with Google"
            onClick={() => {
              setLoadingGoogle(true);
              authService.loginWith(authService.GOOGLE);
            }}
          >
            <img src={GoogleIcon} alt="Sign-in with Google" />
          </button>
        )}
        {permitted?.includes('GitHub') && (
          <button
            className="social-button"
            aria-label="Sign-in with GitHub"
            disabled={loadingGithub}
            onClick={() => {
              setLoadingGithub(true);
              authService.loginWith(authService.GITHUB);
            }}
          >
            <img src={GithubIcon} alt="Sign-in with GitHub" />
          </button>
        )}
        {permitted?.includes('Facebook') && (
          <button
            className="social-button"
            aria-label="Sign-in with Facebook"
            disabled={loadingFacebook}
            onClick={() => {
              setLoadingFacebook(true);
              authService.loginWith(authService.FACEBOOK);
            }}
          >
            <img src={FacebookIcon} alt="Sign-in with Facebook" />
          </button>
        )}
        {permitted?.includes('AppleID') && (
          <button
            className="social-button"
            aria-label="Sign-in with Apple"
            disabled={loadingApple}
            onClick={() => {
              setLoadingApple(true);
              authService.loginWith(authService.APPLE);
            }}
          >
            <img src={AppleIcon} alt="Sign-in with Apple" />
          </button>
        )}
      </div>
      {permitted.length > 0 && <div className="social-logins__separator">or Sign in with</div>}
    </div>
  );
};

SocialLogin.propTypes = {
  permitted: PropTypes.array,
};
